<template>
  <div>
    <base-header type class="rsgradient pb-3 pb-1 pt-3 pt-md-5"></base-header>
    <b-card style="margin: 20px">
      <b-card-header header-tag="header" class="p-1" role="tab">Validación de teléfono</b-card-header>
      <b-card-body>        
          <div class="text-center">
            <img src="@/assets/tel_ok_gris.png" class="img-fluid" />
          </div>
          <div v-show="!model.showPinValidation"> 
            <b-card-text
              class="margin-top text-center"
              style="color:#9c9c9c;"
            ><label>{{this.message}}</label>
            </b-card-text>   
            <div class="row form-group justify-content-center">
              <div class="col-2">
                <Label class="h3 mt-1">Prefijo</Label>
                <base-input v-model="model.prefix" onlyNumbers :maxLength="5" placeholder="Ej.:11"></base-input>
              </div>
              <div class="col-4">
                <Label class="h3 mt-1">Número</Label>
                <base-input v-model="model.telephone" onlyNumbers :maxLength="8" placeholder="Ej.:43239121"></base-input>
              </div>
            </div>            
            <div class="row form-group">
              <div class="col-md-12 text-center">
                <b-button variant="danger" style="background-color:transparent; color:#ff5855;" @click="pinValidate">Continuar</b-button>
              </div>            
            </div>
            <div class="row form-group">
              <div class="col-md-12 text-center">
                <b-button variant="danger" @click="goBack">Volver</b-button>
              </div>
            </div>
          </div>
          <div v-show="model.showPinValidation">
              <b-card-text
                class="margin-top text-center"
                style="color:#9c9c9c;"
              ><label>Te enviamos un número de 6 dígitos por SMS</label>
              </b-card-text>

              <div class="row form-group justify-content-center">
                <div class="col-md-12">
                      <label class="col-md-12 text-center">Código de verificación</label>
                      <div class="col-md-12 text-center" >
                          <pincode-input v-model="code" ref="pincode-input" secure autocomplete="off" :length="this.length" />
                      </div>
                </div>
                <div class="col-md-12 text-center" style="padding:10px;">
                      <div class="col-md-4 center">
                        <base-button type="danger" size="md" @click="validateCode">Validar</base-button>
                    </div>
                </div>
                <div class="col-md-12 text-center" style="padding:10px;">
                    <div class="col-md-4 center">
                        <base-button :disabled ="buttonResend.buttonDisabled" size="md" class="resend" @click="resendCode"><span>{{buttonResend.buttonText}}</span></base-button>
                    </div>
                </div>                
              </div>               
          </div>
      </b-card-body>
    </b-card>
    <!-- <pin-validation ref="pin-validation"
        :showModal.sync="showModalPinValidation"
        v-on:validPin="onValidPin"
        v-on:loadUsePaymentPin="onLoadUsePaymentPin">
    </pin-validation> -->
  </div>
</template>

<style scoped>
.btn-danger {
    border-color:#ff5855; 
    background-color:#ff5855;
}
.resend {
    border-color:#ff5855; 
    background-color:#fff;
    color: #ff5855;
}

.h3.mt-1{
    color: #ff5855; 
}
</style>

<script>
// ******************** Select ********************//
import Vue from "vue";
import vSelect from "vue-select";
Vue.component("v-select", vSelect);
import "vue-select/dist/vue-select.css";
// ******************** Select ********************//

import axiosHelpers from "@/helpers/axiosHelpers";
import notificationHelpers from "@/helpers/notificationHelpers";
import PincodeInput from 'vue-pincode-input';
import PinValidation from '@/views/Pin/PinValidation';

export default {
  components: {"pincode-input": PincodeInput, "pin-validation": PinValidation},
  props: {     
    url: {
      type: String,
      default: "/dashboard",
      description: "Url para realizar push luego de validar"
    },
    message:{
      type: String,
      default: "Verificá tu número de teléfono",
      description: "Mensaje a mostrar en la pantalla de validacion"
    }
  },
  data() {
    return {
      code:"" ,
      length: 6,
      model: {
        prefix : "",
        telephone : "",
        showPinValidation: false,
        showMsgResult: false,
        numberComplete :0
      },
      buttonResend:{
         buttonText: "Reenviar Código",
         buttonDisabled: false
        },
      paramCountDown: 0,
      countDown: 0,
      usePaymentPin: false,
      // showModalPinValidation: false,     
    };
  },

  mounted() {
    let context = this;    
    let param = { };
    axiosHelpers.axiosPost("Account/GetAccountTelephoneForValidation", param, this, (data) => { 
      context.model.prefix = data.ResponseVM.Prefix;
      context.model.telephone = data.ResponseVM.Telephone; 
      context.model.numberComplete = context.model.prefix + context.model.telephone;
    });   
  },
  methods: {
    validateCode:function(){
      let context = this;
      var param = { Code:context.code, Prefix:context.model.prefix, PhoneNumber: context.model.telephone};
      axiosHelpers.axiosPost("DoubleFactorSecurity/ValidateTelephoneMethod", param, this, function(data) {
        if(data.ResponseVM.Result){
          notificationHelpers.showSuccess("Validación de Teléfono", "Se ha validado el teléfono correctamente", context);
          context.$store.dispatch("PhoneVerify",data.ResponseVM.Result);        
          context.$router.push(context.url);
        }
        else
        {
          context.code = "";
        }                
      });
    },    
    goBack() {
      this.$router.go(-1);
    },    
    resendCode:function(){
        let context = this;
        let param = {
        SelectedMethodID: context.$store.getters.SMSCodeMethodID,
        Aux: context.model.prefix + context.model.telephone };
        axiosHelpers.axiosPost("DoubleFactorSecurity/GenerateSecurityCodeAndSendForDataModification", param, this, (data) => { 
          if(data.ResponseVM.Result){
            context.paramCountDown = data.ResponseVM.TimeToResend;
            context.buttonResend.buttonDisabled = true;
            context.countDownTimer();
          }
          else{
            notificationHelpers.showError("Validación", "No se ha podido validar su teléfono. Intente nuevamente", this);
          }
        });        
    },
    countDownTimer() {
          let context = this;
          if(context.paramCountDown > 0) {
              setTimeout(() => {
                  context.paramCountDown -= 1;
                  if(context.paramCountDown == 1)
                    context.buttonResend.buttonText = 'Disponible en ' + context.paramCountDown.toString() + ' segundo';
                  else                                     
                    context.buttonResend.buttonText = 'Disponible en ' + context.paramCountDown.toString() + ' segundos';
                  this.countDownTimer();
              }, 1000)
          }
          else{
            context.buttonResend.buttonText = 'Reenviar Código';
            context.buttonResend.buttonDisabled = false;
          }
    }, 
    SendValidationCode(){
      let context = this;  
      let params = {
        SelectedMethodID: context.$store.getters.SMSCodeMethodID,
        Aux: context.model.prefix + context.model.telephone 
      };
      axiosHelpers.axiosPost(
        "DoubleFactorSecurity/GenerateSecurityCodeAndSendForDataModification",
        params,
        this,
        function(data) {
          if(data.ResponseVM.Result){
            context.model.showPinValidation = true;
            context.paramCountDown = data.ResponseVM.TimeToResend;
            context.buttonResend.buttonDisabled = true;
            context.countDownTimer();
          }
          else{
            notificationHelpers.showError("Validación", "No se ha podido validar su teléfono. Intente nuevamente", this);
          }          
        }
      );

    },
    onValidPin(val){
      let context = this;
      if(val) {
          context.SendValidationCode();
      }
    },
    onLoadUsePaymentPin(val){
      let context = this;
      context.usePaymentPin = val;
    },
    pinValidate() {
      let context = this;
      // let newNumberComplete = context.model.prefix + context.model.telephone;
      // if(context.usePaymentPin && (newNumberComplete != context.model.numberComplete)) {
      //     context.showModalPinValidation = true;
      // } else {
          context.SendValidationCode();
      // }
    }
  },
  computed: {
    
  },
  beforeMount: function() {
    
  },
  watch: {
    
  }
};
</script>